// extracted by mini-css-extract-plugin
module.exports = {"WrapperFeaturedShortmessagesHighlights":"_5rSv","InnerFeaturedShortmessages":"FubJ","InnerHighlights":"llC_"};